// extracted by mini-css-extract-plugin
export var divider = "_pv-0";
export var systemMessage = "_pv-1";
export var systemMessageWrapper = "_pv-2";